import * as React from 'react'
import { FC } from 'react'
import { SoldServicesIcon } from './SoldServicesIcon'
import { soldServiceStatusText } from './utils/soldServiceStatusText'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import Box from '@mui/material/Box'
import { Theme, useTheme } from '@mui/material/styles'

interface Props {
  details?: React.ReactNode
  hideTitle?: boolean
  soldServiceStatus: SOLD_SERVICE_STATUS
  textColor: string
}

const getStyles = (theme: Theme) => ({
  icon: {
    marginRight: theme.spacing(1.2),
  },

  root: {
    alignItems: 'center',
    display: 'flex',
  },
})
export const SoldServiceStatus: FC<Props> = (props) => {
  const {
    details,
    hideTitle = false,
    soldServiceStatus: status,
    textColor,
  } = props
  const styles = getStyles(useTheme())
  return (
    <Box
      sx={styles.root}
      flexDirection="row"
      component="div"
      style={{ color: textColor }}
    >
      <Box sx={styles.icon}>
        <SoldServicesIcon status={status} />
      </Box>
      <Box>
        {!hideTitle && <span>Status: </span>}
        {soldServiceStatusText(status)}
        {details && ' '}
        {details}
      </Box>
    </Box>
  )
}
SoldServiceStatus.displayName = 'SoldServiceStatus'
